import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "@redux/auth/auth";
import permissionReducer from "@redux/auth/permission";
import tokenData from "@redux/auth/tokenData";
import userSlice from "@redux/auth/userSlice";
import loaderSlice from "@redux/loaderSlice";

// Combine all reducers
const rootReducer = combineReducers({
  auth: authReducer,
  permission: permissionReducer,
  tokenData: tokenData,
  loader: loaderSlice,
  user: userSlice,
});

// Configure persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "permission", "user"], // Add reducers you want to persist
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
